import React from "react";
import { Col, Input, Label, Row } from "reactstrap";
import { useTranslation } from "react-i18next";

export const BANCO_VACIO = { moneda: "", banco: "", beneficiario: "", cuenta: "", clabe: "", swift: "", abba: "", direccion: "" };

// La CLABE es opcional (las navieras extranjeras no tienen), pero si se captura son 18 dígitos
export const clabeValida = (clabe) => !clabe || /^\d{18}$/.test(clabe.trim());

const TEXTOS = [
  ["banco", "Banco", 5],
  ["beneficiario", "Beneficiario", 4],
  ["cuenta", "Cuenta", 4],
  ["clabe", "Clabe", 4],
  ["swift", "Swift", 4],
  ["abba", "ABBA", 4],
];

// Datos bancarios de la naviera: mismos campos en el alta y en la edición
export default function CamposBanco({ valores, set }) {
  const [t] = useTranslation("global");
  return (
    <Row>
      <Col md={3} className="mb-2">
        <Label>{t("Moneda")}</Label>
        <Input type="select" value={valores.moneda} onChange={(e) => set("moneda", e.target.value)}>
          <option value="">{t("Selecciona")}</option>
          <option value="MXN">MXN</option>
          <option value="USD">USD</option>
        </Input>
      </Col>
      {TEXTOS.map(([campo, label, md]) => (
        <Col key={campo} md={md} className="mb-2">
          <Label>{t(label)}</Label>
          <Input type="text" value={valores[campo]} onChange={(e) => set(campo, e.target.value)} />
        </Col>
      ))}
      <Col md={12} className="mb-2">
        <Label>{t("Dirección")}</Label>
        <Input type="text" value={valores.direccion} onChange={(e) => set("direccion", e.target.value)} />
      </Col>
    </Row>
  );
}
